<template>
    <div>
        <div v-show="!areZonesValid">Published forecasts need at least one zone</div>
        <div v-if="isShowSelectButtons">
            <ClientColorButton :disabled="areAllSelected" @click="selectAll">Select all</ClientColorButton>
            <ClientColorButton :disabled="areAllUnSelected" @click="unselectAll">Select none</ClientColorButton>
        </div>
        <div class="options">
            <div class="option" v-for="brandZone in allBrandZone" :key="brandZone.id" v-if="brandZone.active || forecast.id">
                <div>
                    <div :class="{ hidden: !brandZone.zoneRelationType.multivalidation }" class="multiValidation"><MarketIcon /></div>
                </div>
                <div>
                    <input
                        :disabled="isDisabled(brandZone.zone) || isDeleted(brandZone.zone)"
                        :checked="isZoneChecked(brandZone.zone)"
                        :id="`zone_${brandZone.zone.id}`"
                        type="checkbox"
                        :value="brandZone.zone.id"
                        @change="onZoneChange($event.target.value)"
                    />
                </div>
                <div>
                    <label :class="{ disabled: !hasUserAccessToZone(brandZone.zone) || disabled }" :for="`zone_${brandZone.zone.id}`">
                        {{ brandZone.zone.name }} <span v-if="isDeleted(brandZone.zone)"><i>(DELETED)</i></span>
                    </label>
                </div>
            </div>
        </div>
        <div v-if="isShowSelectButtons">
            <ClientColorButton :disabled="areAllSelected" @click="selectAll">Select all</ClientColorButton>
            <ClientColorButton :disabled="areAllUnSelected" @click="unselectAll">Select none</ClientColorButton>
        </div>
    </div>
</template>
<script>
import CheckboxGroupBloc from "@/components/ui/Form/CheckboxGroupBloc";
import MarketIcon from "@/components/forecasts/elements/icons/MarketIcon";
import forecastsService from "@/components/forecasts/forecastsService";
import ForecastValidator from "@/components/forecasts/validation/forecastValidator";

export default {
    components: {
        MarketIcon,
        CheckboxGroupBloc
    },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        selectedZones: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            zonesErrorMessage: "",
            localSelectedZones: null,
            allBrandZone: []
        };
    },
    async created() {
        this.localSelectedZones = this.selectedZones;
        this.allBrandZone = await forecastsService.getUserBrandZones();
        this.allBrandZone.sort((a, b) => {
            return (
                b.zoneRelationType.multivalidation - a.zoneRelationType.multivalidation ||
                (a.zone.name.toLowerCase() < b.zone.name.toLowerCase() ? -1 : 1)
            );
        });
    },
    computed: {
        areZonesValid() {
            return ForecastValidator.canUpdate(this.forecast) || this.localSelectedZones.length > 0;
        },
        accessibleBrandZones() {
            return this.allBrandZone.filter(brandZone => this.hasUserAccessToZone(brandZone.zone));
        },
        areAllSelected() {
            return !this.accessibleBrandZones.find(abz => !this.localSelectedZones.find(lsz => lsz.id === abz.zone.id));
        },
        areAllUnSelected() {
            return !this.accessibleBrandZones.find(abz => this.localSelectedZones.find(lsz => lsz.id === abz.zone.id));
        },
        isShowSelectButtons() {
            return ForecastValidator.canUpdate(this.forecast);
        }
    },
    methods: {
        updateZones() {
            if (this.areZonesValid) {
                this.$emit("update", this.localSelectedZones);
            }
        },
        onZoneChange(zoneId) {
            let brandZone = this.allBrandZone.find(brandZone => brandZone.zone.id === parseInt(zoneId));
            let zone = brandZone.zone;
            let zoneSelection = this.localSelectedZones;
            if (zoneSelection.some(selectedZone => selectedZone.id === zone.id)) {
                zoneSelection = zoneSelection.filter(selectedZone => selectedZone.id !== zone.id);
            } else {
                zoneSelection.push(zone);
            }
            this.localSelectedZones = zoneSelection;
            this.updateZones();
        },
        hasUserAccessToZone(zone) {
            return this.allBrandZone.some(zoneForUser => zoneForUser.zone.id === zone.id);
        },
        isZoneChecked(zone) {
            return this.localSelectedZones.some(sZone => sZone.id === zone.id);
        },
        selectAll() {
            let zoneSelection = this.localSelectedZones;
            this.accessibleBrandZones
                .filter(bz => bz.active)
                .forEach(aBrandZone => {
                    if (!zoneSelection.find(zone => zone.id === aBrandZone.zone.id)) {
                        zoneSelection.push(aBrandZone.zone);
                    }
                });
            this.localSelectedZones = zoneSelection;
            this.updateZones();
        },
        unselectAll() {
            this.localSelectedZones = this.localSelectedZones.filter(
                selectedZone => !this.hasUserAccessToZone(selectedZone) || this.isDeleted(selectedZone)
            );
            this.updateZones();
        },
        isDisabled(zone) {
            if (this.disabled) {
                return true;
            }

            if (!this.hasUserAccessToZone(zone)) {
                return true;
            }
            if (ForecastValidator.canUpdate(this.forecast)) {
                return false;
            }
            // is the only selected zone the current zone? Disable to option to avoid empty zones for forecasts which are not in DRAFT
            return this.localSelectedZones.length === 1 && this.localSelectedZones.find(selectZone => selectZone.id === zone.id);
        },
        isDeleted(zone) {
            const brandZone = this.allBrandZone.find(bz => bz.zone.id === zone.id);
            if (!brandZone) {
                return true;
            }
            return !brandZone.active;
        }
    }
};
</script>
<style lang="scss" scoped>
label.disabled {
    color: #b3b0b0;
}
button {
    padding: 2px !important;
}
.options {
    margin: 10px 0;
    .option {
        padding: 5px 10px;
        display: flex;
        div {
            margin-right: 3px;
        }
    }
}
.multiValidation {
    height: 15px;
    width: 15px;
    display: inline-block;
}
.hidden {
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// ZoneSelection.vue?7e4ec72d